// extracted by mini-css-extract-plugin
module.exports = {"root":"ProjectListingModalContent_root__2bJGN","sectionIconWrapper":"ProjectListingModalContent_sectionIconWrapper__szKJz","longWord":"ProjectListingModalContent_longWord__1zFPz"};